import { useEffect } from 'react'
import { SimpleModalProps } from '../../modals/simpleModal'
import { useTranslator } from '../../translator/hook'
import Modal from 'react-modal'
import { SmallButton } from '../../buttons/smallButton'
import '../../../styles/modal.css'
import './downloadModal.css'
import downloadManual from '../../../assets/download-manual.svg'
import helpImg2 from '../../../assets/reconnect-manual-2.svg'
import TriangleIcon from '@/components/icons/triangleIcon'
import { useLinkage } from '../../linkage/useLinkage'
import { toast } from 'react-toastify'

interface DownloadModalProps extends Pick<SimpleModalProps, 'onClose'> {
  isOpen: boolean
  onClose(): void
}

export const DownloadModal = ({ isOpen, onClose }: DownloadModalProps) => {
  Modal.setAppElement('#root')
  const { t } = useTranslator()
  const { code, connected } = useLinkage()

  useEffect(() => {
    if (connected && isOpen) {
      onClose()
    }
  }, [connected, isOpen, onClose, t])

  return (
    <Modal
      className="modal-content"
      isOpen={isOpen}
      contentLabel="Download Modal"
      onRequestClose={onClose}
      style={{
        overlay: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 861,
        },
      }}
    >
      <div className="download-modal-container">
        <div className="download-modal-header">
          <div className="download-modal-title">
            {t('modal_download_title')}
          </div>
        </div>

        <div className="download-modal-content">
          <div className="download-modal-card">
            <div className="download-modal-card-title">
              {t('modal_download_card_title')}
            </div>
            <div className="download-modal-card-image card-image">
              <img src={downloadManual} alt={'downloaded'} />
            </div>
          </div>
          <TriangleIcon />
          <div className="download-modal-card">
            <div className="download-modal-card-title">
              {t('reconnect_step2')}
            </div>
            <div className="download-modal-card-image card-image">
              <img src={helpImg2} alt={'help2'} />
            </div>
          </div>
        </div>
      </div>
      <div className="download-modal-footer">
        <div className="download-modal-code-section">
          <span className="download-modal-code-label">
            {t('linkage_connection_code').replace(/{CODE}/g, code)}
          </span>
          <SmallButton
            className="linkage-copy-small-button"
            onClick={() => {
              navigator.clipboard.writeText(code)
              toast.success(t('linkage_code_copied'))
            }}
          >
            {t('linkage_copy_button')}
          </SmallButton>
        </div>
      </div>
    </Modal>
  )
}
